import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animallist',
  templateUrl: './animallist.component.html',
  styleUrls: ['./animallist.component.scss']
})
export class AnimallistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
